var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description)?_c('div',{staticClass:"rb-stock-status-description"},[(_vm.useDash)?_c('span',{staticClass:"rb-dash"},[_vm._v(" - ")]):_vm._e(),_vm._v(_vm._s(_vm.description)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }